import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
require("frappe-gantt/dist/frappe-gantt");
import Gantt from "frappe-gantt";
export default class extends ApplicationController {
    connect() {
        console.log("*** Gantt Visualization ***");
        var tasks = this.tasks;
        if (tasks){
            tasks = eval(tasks.replaceAll("\\",""));
        }
        const locale = navigator.language.substring(0, 2);
        const gantt_chart  = new Gantt("#gantt", tasks, {
            header_height: 50,
            column_width: 30,
            step: 24,
            bar_height: 20,
            bar_corner_radius: 3,
            arrow_curve: 5,
            padding: 18,
            view_mode: 'Month',
            date_format: 'DD/MM/YYYY',
            language: locale,
            on_click: function (task) {
                toggleBars(task);
            },
            popup_trigger: 'mouseover',
            custom_popup_html: function(task) {
              // the task object will contain the updated
              // dates and progress value
              return `
               <div class="title">${task.name}</div>
               <div class="subtitle">
                <p>Date de début ${formatDate(task._start)} </p>
                <p>Date de fin ${formatDate(task._end)}</p>
                <p>Budget ${task.budget} </p>
                <p>Avancement ${task.progress}%</p>
               </div>
              `;
            },
            on_view_change: function() {
                var bars = document.querySelectorAll("#gantt" + " .bar-group");
                for (var i = 0; i < bars.length; i++) {
                    bars[i].addEventListener("mousedown", stopEvent, true);
                }
                var handles = document.querySelectorAll("#gantt" + " .handle-group");
                for (var i = 0; i < handles.length; i++) {
                    handles[i].remove();
                }
                $(".father").children().find(".bar-progress").css({"fill": "orange"});
                $(".father").children().find(".bar-progress").css({"height": "25px"});
                $(".father").children().find(".bar").css({"height": "25px"});
                $(".father").children().find(".bar").css({"fill": "#1d4958"});
                $(".absolute_father").children().find(".bar").css({"fill": "rgb(0 142 191)"});
                $(".father").children().find(".bar-label").css({"text-decoration": "underline","font-size": "15px"});
            }
        });
        document.querySelector('.js-view').addEventListener('click', changeView, false);
        document.querySelector('#expand').addEventListener('click', expandAllBars, false);
        document.querySelector('#collapseBudget').addEventListener('click', collapseBudget , false);
        function stopEvent(event) {
            event.preventDefault();
            event.stopPropagation();
        }
        function padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        }
        function formatDate(date) {
          return [
            padTo2Digits(date.getDate()),
            padTo2Digits(date.getMonth() + 1),
            date.getFullYear(),
          ].join('/');
        }
        /* ////////////////////////////  */
        function toggleBars(task) {
            let children = task.children;
            let index = gantt_chart.parents.indexOf(task.id);
            (index === -1) ? gantt_chart.parents.push(task.id) : gantt_chart.parents.splice(index, 1);

            gantt_chart.tasks_to_display.map(item => {
                let indexChild = children.indexOf(item.id);
                if (indexChild !== -1) {
                    if (!item.display && !item.parent) {
                        item.display = "none";
                        item.parent = task.id;
                    } else if (!item.display && item.parent) {
                        item.display = item.display;
                        item.parent = item.parent;
                    } else if (item.display && item.parent !== task.id) {
                        item.display = item.display;
                        item.parent = item.parent;
                    } else {
                        item.display = "";
                        item.parent = "";
                    }
                } else if (item.id === task.id) {
                    item.collapsed = (!item.collapsed) ? true : "";
                } else if (item.id !== task.id) {
                    item.collapsed = item.collapsed;
                }

                gantt_chart.tasks_all[item.id] = item;

                return item;
                $(".father").children().find(".bar-progress").css({"fill": "orange"});
                $(".father").children().find(".bar-progress").css({"height": "25px"});
                $(".father").children().find(".bar").css({"height": "25px"});
                $(".father").children().find(".bar").css({"fill": "#1d4958"});
                $(".absolute_father").children().find(".bar").css({"fill": "rgb(0 142 191)"});
                $(".father").children().find(".bar-label").css({"text-decoration": "underline","font-size": "15px"});
            });

            gantt_chart.refresh(gantt_chart.tasks_to_display.filter(task => !task.display));

            let check = (gantt_chart.tasks_to_display.length !== gantt_chart.tasks.length);
            gantt_chart.parents = !check ? [] : gantt_chart.parents;

            toggleClassBars(check);
            $(".father").children().find(".bar-progress").css({"fill": "orange"});
            $(".father").children().find(".bar-progress").css({"height": "25px"});
            $(".father").children().find(".bar").css({"height": "25px"});
            $(".father").children().find(".bar").css({"fill": "#1d4958"});
            $(".absolute_father").children().find(".bar").css({"fill": "rgb(0 142 191)"});
            $(".father").children().find(".bar-label").css({"text-decoration": "underline","font-size": "15px"});
        }
        /* ////////////////////////////  */
        function toggleClassBars(check) {
            document.querySelectorAll('.bar-wrapper')
            .forEach(el => (gantt_chart.parents.indexOf(el.dataset.id) !== -1 && check) ?
                    el.classList.add('parent') : el.classList.remove('parent')
            );
        }
         /* ////////////////////////////  */
        function changeView(event) {
            event.target.parentNode.childNodes.forEach(childNode => {
                let view = event.target.dataset.view;
                if (childNode.tagName === "BUTTON") {
                    if (childNode.dataset.view === view) {
                        gantt_chart.change_view_mode(view);
                        childNode.classList.add("selected");
                    } else {
                        childNode.classList.remove("selected");
                    }
                }
            });
            $(".father").children().find(".bar-progress").css({"fill": "orange"});
            $(".father").children().find(".bar-progress").css({"height": "25px"});
            $(".father").children().find(".bar").css({"height": "25px"});
            $(".father").children().find(".bar").css({"fill": "#1d4958"});
            $(".absolute_father").children().find(".bar").css({"fill": "rgb(0 142 191)"});
            $(".father").children().find(".bar-label").css({"text-decoration": "underline","font-size": "15px"});
        }
        /* ////////////////////////////  */
        function collapseAll() {
            let tasks = gantt_chart.tasks_to_display ? gantt_chart.tasks_to_display : gantt_chart.tasks;
            tasks.map(task => {
                    if (!task.collapsed) {
                        toggleBars(task);
                    }
            });
            $(".father").children().find(".bar-progress").css({"fill": "orange"});
            $(".father").children().find(".bar-progress").css({"height": "25px"});
            $(".father").children().find(".bar").css({"height": "25px"});
            $(".father").children().find(".bar").css({"fill": "#1d4958"});
            $(".absolute_father").children().find(".bar").css({"fill": "rgb(0 142 191)"});
            $(".father").children().find(".bar-label").css({"text-decoration": "underline","font-size": "15px"});
        }
        function collapseBudget() {
            let tasks = gantt_chart.tasks_to_display ? gantt_chart.tasks_to_display : gantt_chart.tasks;
            tasks.map(task => {
                if (!task.collapsed && parseInt(task.is_budget) == 1) {
                    console.log(task)
                    toggleBars(task);
                }
            });
            gantt_chart.refresh(tasks.filter(task => !( parseInt(task.is_budget) == 1 ) ));
            $(".father").children().find(".bar-progress").css({"fill": "orange"});
            $(".father").children().find(".bar-progress").css({"height": "25px"});
            $(".father").children().find(".bar").css({"height": "25px"});
            $(".father").children().find(".bar").css({"fill": "#1d4958"});
            $(".absolute_father").children().find(".bar").css({"fill": "rgb(0 142 191)"});
            $(".father").children().find(".bar-label").css({"text-decoration": "underline","font-size": "15px"});
            $("#expand").show();
            $("#collapseBudget").hide();
        }
        
        /* ////////////////////////////  */
        function expandBars(task) {
            let tasks = gantt_chart.tasks_to_display ? gantt_chart.tasks_to_display : gantt_chart.tasks;
            let tasks_to_display;
           
            let index = gantt_chart.parents.indexOf(task.id);
            if (task.collapsed && index !== -1)
                gantt_chart.parents.splice(index, 1);
            tasks_to_display = tasks.map(item => {
                if (task.children.indexOf(item.id) !== -1) {
                    index = gantt_chart.parents.indexOf(item.id);
                    if (index !== -1) gantt_chart.parents.splice(index, 1);
                     item.display = "";
                    item.parent = "";
                    item.collapsed = "";
                } else if (task.id === item.id) {
                    item.display = "";
                    item.parent = "";
                    item.collapsed = "";
                } else {
                    item.display = item.display;
                    item.parent = item.parent;
                    item.collapsed = item.collapsed;
                }
                 gantt_chart.tasks_all[item.id] = item;
                 return item;
            });
            gantt_chart.tasks_to_display = tasks_to_display;
            let check = (gantt_chart.tasks_to_display.length !== gantt_chart.tasks.length);
            gantt_chart.refresh(tasks_to_display.filter(task => !task.display));
            toggleClassBars(check);
            $(".father").children().find(".bar-progress").css({"fill": "orange"});
            $(".father").children().find(".bar-progress").css({"height": "25px"});
            $(".father").children().find(".bar").css({"height": "25px"});
            $(".father").children().find(".bar").css({"fill": "#1d4958"});
            $(".absolute_father").children().find(".bar").css({"fill": "rgb(0 142 191)"});
            $(".father").children().find(".bar-label").css({"text-decoration": "underline","font-size": "15px"});
        }
        function expandAllBars(){
            let tasks = gantt_chart.tasks_to_display ? gantt_chart.tasks_to_display : gantt_chart.tasks;
            let tasks_to_display;

            tasks_to_display = tasks.map(item => {
                item.display = "";
                item.parent = "";
                item.collapsed = "";
                gantt_chart.tasks_all[item.id] = item;
                return item;
            });
            gantt_chart.parents = [];
            gantt_chart.tasks_to_display = tasks_to_display;
            let check = (gantt_chart.tasks_to_display.length !== gantt_chart.tasks.length);
            gantt_chart.refresh(tasks_to_display.filter(task => !task.display));
            toggleClassBars(check);
            $(".father").children().find(".bar-progress").css({"fill": "orange"});
            $(".father").children().find(".bar-progress").css({"height": "25px"});
            $(".father").children().find(".bar").css({"height": "25px"});
            $(".father").children().find(".bar").css({"fill": "#1d4958"});
            $(".absolute_father").children().find(".bar").css({"fill": "rgb(0 142 191)"});
            $(".father").children().find(".bar-label").css({"text-decoration": "underline","font-size": "15px"});
            $("#expand").hide();
            $("#collapseBudget").show();
        }
        tasks.forEach(task => {
            task.children = gantt_chart.get_all_dependent_tasks(task.id);
            task.display = "";
            task.parent = "";
            task.collapsed = "";
        });
        let tasks_all = {}
        gantt_chart.tasks.forEach(item => {
            tasks_all[item.id] = item;
        });
        gantt_chart.tasks_all = tasks_all;
        gantt_chart.parents = [];
        gantt_chart.tasks_to_display = gantt_chart.tasks;
        $("#collapseBudget").click();
        MicroModal.close("gantt_diagram_suivi");
        $(".father").children().find(".bar-progress").css({"fill": "orange"});
        $(".father").children().find(".bar-progress").css({"height": "25px"});
        $(".father").children().find(".bar").css({"height": "25px"});
        $(".father").children().find(".bar").css({"fill": "#1d4958"});
        $(".absolute_father").children().find(".bar").css({"fill": "rgb(0 142 191)"});
        $(".father").children().find(".bar-label").css({"text-decoration": "underline","font-size": "15px"});
        $("#expand").show();
        $("#collapseBudget").hide();
        
    }


    /* getters */
    get tasks() {
        return this.data.get("tasks");
    }
}

